function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["scope", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var $hnlpS$react = require("react");
var $hnlpS$radixuireactcontext = require("@radix-ui/react-context");
var $hnlpS$radixuireactcomposerefs = require("@radix-ui/react-compose-refs");
var $hnlpS$radixuireactslot = require("@radix-ui/react-slot");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "createCollection", function () {
  return $1a96635ec239608b$export$c74125a8e3af6bb2;
});

// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $1a96635ec239608b$export$c74125a8e3af6bb2(name) {
  /* -----------------------------------------------------------------------------------------------
  * CollectionProvider
  * ---------------------------------------------------------------------------------------------*/
  var PROVIDER_NAME = name + 'CollectionProvider';
  var _$hnlpS$radixuireactc = $hnlpS$radixuireactcontext.createContextScope(PROVIDER_NAME),
    _$hnlpS$radixuireactc2 = _slicedToArray(_$hnlpS$radixuireactc, 2),
    createCollectionContext = _$hnlpS$radixuireactc2[0],
    createCollectionScope = _$hnlpS$radixuireactc2[1];
  var _createCollectionCont = createCollectionContext(PROVIDER_NAME, {
      collectionRef: {
        current: null
      },
      itemMap: new Map()
    }),
    _createCollectionCont2 = _slicedToArray(_createCollectionCont, 2),
    CollectionProviderImpl = _createCollectionCont2[0],
    useCollectionContext = _createCollectionCont2[1];
  var CollectionProvider = function CollectionProvider(props) {
    var scope = props.scope,
      children = props.children;
    var ref = $parcel$interopDefault($hnlpS$react).useRef(null);
    var itemMap = $parcel$interopDefault($hnlpS$react).useRef(new Map()).current;
    return /*#__PURE__*/$parcel$interopDefault($hnlpS$react).createElement(CollectionProviderImpl, {
      scope: scope,
      itemMap: itemMap,
      collectionRef: ref
    }, children);
  };
  /*#__PURE__*/
  Object.assign(CollectionProvider, {
    displayName: PROVIDER_NAME
  });
  /* -----------------------------------------------------------------------------------------------
  * CollectionSlot
  * ---------------------------------------------------------------------------------------------*/
  var COLLECTION_SLOT_NAME = name + 'CollectionSlot';
  var CollectionSlot = /*#__PURE__*/$parcel$interopDefault($hnlpS$react).forwardRef(function (props, forwardedRef) {
    var scope = props.scope,
      children = props.children;
    var context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    var composedRefs = $hnlpS$radixuireactcomposerefs.useComposedRefs(forwardedRef, context.collectionRef);
    return /*#__PURE__*/$parcel$interopDefault($hnlpS$react).createElement($hnlpS$radixuireactslot.Slot, {
      ref: composedRefs
    }, children);
  });
  /*#__PURE__*/
  Object.assign(CollectionSlot, {
    displayName: COLLECTION_SLOT_NAME
  });
  /* -----------------------------------------------------------------------------------------------
  * CollectionItem
  * ---------------------------------------------------------------------------------------------*/
  var ITEM_SLOT_NAME = name + 'CollectionItemSlot';
  var ITEM_DATA_ATTR = 'data-radix-collection-item';
  var CollectionItemSlot = /*#__PURE__*/$parcel$interopDefault($hnlpS$react).forwardRef(function (props, forwardedRef) {
    var scope = props.scope,
      children = props.children,
      itemData = _objectWithoutProperties(props, _excluded);
    var ref = $parcel$interopDefault($hnlpS$react).useRef(null);
    var composedRefs = $hnlpS$radixuireactcomposerefs.useComposedRefs(forwardedRef, ref);
    var context = useCollectionContext(ITEM_SLOT_NAME, scope);
    $parcel$interopDefault($hnlpS$react).useEffect(function () {
      context.itemMap.set(ref, _objectSpread({
        ref: ref
      }, itemData));
      return function () {
        return void context.itemMap.delete(ref);
      };
    });
    return /*#__PURE__*/$parcel$interopDefault($hnlpS$react).createElement($hnlpS$radixuireactslot.Slot, _defineProperty(_defineProperty({}, ITEM_DATA_ATTR, ''), "ref", composedRefs), children);
  });
  /*#__PURE__*/
  Object.assign(CollectionItemSlot, {
    displayName: ITEM_SLOT_NAME
  });
  /* -----------------------------------------------------------------------------------------------
  * useCollection
  * ---------------------------------------------------------------------------------------------*/
  function useCollection(scope) {
    var context = useCollectionContext(name + 'CollectionConsumer', scope);
    var getItems = $parcel$interopDefault($hnlpS$react).useCallback(function () {
      var collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      var orderedNodes = Array.from(collectionNode.querySelectorAll("[".concat(ITEM_DATA_ATTR, "]")));
      var items = Array.from(context.itemMap.values());
      var orderedItems = items.sort(function (a, b) {
        return orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current);
      });
      return orderedItems;
    }, [context.collectionRef, context.itemMap]);
    return getItems;
  }
  return [{
    Provider: CollectionProvider,
    Slot: CollectionSlot,
    ItemSlot: CollectionItemSlot
  }, useCollection, createCollectionScope];
}